/**
 * The colours a tag can be given.
 *
 * A fixed palette rather than a colour picker. The swatch renders as a bare 8px dot with no
 * border to lift it, over `surface-raised` in both themes — #f7f7f8 in light, #1b1b1f in dark. A
 * free picker lets someone choose a colour that disappears into one of the two, and they will not
 * find out until they switch theme. Every entry below clears roughly 3:1 against both
 * backgrounds, which is what the dot needs to read as a deliberate mark rather than a smudge.
 *
 * The API accepts any valid `#rrggbb`, so this is the client narrowing its own choices, not a
 * rule. A colour set by hand elsewhere still renders.
 */
export interface TagColor {
  /** Shown as the swatch's accessible name — the dot itself carries no text. */
  name: string;
  value: string;
}

export const tagColors: readonly TagColor[] = [
  { name: 'Grey', value: '#6b7280' },
  { name: 'Red', value: '#e5484d' },
  { name: 'Orange', value: '#e2620a' },
  { name: 'Amber', value: '#b98900' },
  { name: 'Green', value: '#2e9c63' },
  { name: 'Teal', value: '#0d9488' },
  { name: 'Blue', value: '#1a80e0' },
  { name: 'Violet', value: '#8e4ec6' },
  { name: 'Pink', value: '#d6409f' },
];
